// extracted by mini-css-extract-plugin
export default {"textarea":"AutoHeightTextarea_textarea__vcE8l","text_full":"AutoHeightTextarea_text_full__eO4GN"};